import React from 'react';
import { BadgeProps } from '@mui/material/Badge/Badge';
import BadgeStyled from './styles';

export default function AvatarBadge({ ...badgeProps }: BadgeProps) {
  return <BadgeStyled {...badgeProps} />;
}
